<template>
    <FormField :label="label" :errors="errors" :icon="icon" :focuscb="onParentFocus" :name="name">
        <div class="flex gap-4 items-center">
            <slot name="before"></slot>
            <input ref="input" :id="name" :value="modelValue" :autocomplete="name" :name="name" :type="type"
                @input="onValueChange($event.target.value)">
        </div>
    </FormField>
</template>
<script>
import FormField from './FormField.vue'
export default {
    name: 'TextFormField',
    components: {
        FormField
    },
    props: {
        label: {
            type: String,
            required: true
        },
        errors: {
            type: [Array, null, undefined],
            required: false
        },
        icon: {
            type: String,
            required: true
        },
        modelValue: {
            required: false,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            required: true
        },
    },
    emits: ['update:modelValue'],
    methods: {
        onParentFocus(event) {
            // If click is inside a vue-multiselect element (dropdown or control), do nothing
            if (event.target.closest('.multiselect, .multiselect__option, .multiselect__content-wrapper, .multiselect__single, .multiselect__tags')) {
                return;
            }
            // Find the container for the 'before' slot and the input
            const container = event.currentTarget.querySelector('.input-group-container');
            if (!container) return;

            // Get the first child element within the container, which should be the slotted component (Multiselect)
            const slotElement = container.firstElementChild;

            // If the click target is the slot element or inside it, do not shift focus
            if (slotElement && slotElement.contains(event.target)) {
                return;
            }

            // Otherwise, proceed to focus the input element
            this.$refs.input.focus()
        },
        onValueChange(value) {
            this.$emit('update:modelValue', value)
        }
    }
}
</script>